import { validationSchemaPaet } from "../../utils/validationSchemaForm";
import axios from "axios";
import { Field, Form, Formik } from "formik";
import MaskedInput from "react-text-mask";
import { rutMask } from "../../utils/inputMask";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import React, { useState } from "react";
import Swal from "sweetalert2";
import ConfigurationManager from "../../settings/ConfigurationManager";
import { oacento } from "../../utils/caracteresUTF8";
import { cleanRut, convertirRutAId } from "../../utils/cleanInputMask";

const FormConsultar = () => {

	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const MySwal = Swal.mixin({
		customClass: {
			confirmButton: "btn btn-success",
			title: "font-weight-bold text-left",
			footer: "swal-footer",
		},
		buttonsStyling: false,
	});

	const initialValues = {
		rut: "",
		numerosolicitud: "",
	};

	const onSubmit = (values) => {
		setIsLoading(true);

		let rut = cleanRut(values.rut);
		let id = convertirRutAId(rut);

		axios({
			method: "GET",
			url: `${ConfigurationManager.API_URL}/ConsultaFolio/DatosAfiliado?rutceros=${id}`,
			headers: ConfigurationManager.JSON_HEADER,
		})
			.then((response) => {
				if (response.data.ok) {
					let tieneTramite =
						response.data.resultado.afiliado.indTieneTramite === "S";

					if (!tieneTramite) {
						MySwal.fire({
							title: "¡No pudimos validar los datos ingresados!",
							icon: "error",
							text: "Los datos ingresados no coinciden con nuestros registros de solicitud de pensión PAET. Por favor, verifica que sean correctos o hayas ingresado previamente una solicitud.",
							confirmButtonText: "Aceptar",
						}).then((result) => {
							setIsLoading(false);
						});
					} else {
						localStorage.setItem("idPersona", id);
						window.location = "comprobanteEstadoSolicitud";
						setIsLoading(false);
					}
				}
			})
			.catch((e) => {
				console.error(e);
			});
	};

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchemaPaet} onSubmit={onSubmit}>
			{(formik) => (
				<Form>
					<span>
						RUT del afiliado, pensionado o beneficiario de pensi{oacento}n de
						sobrevivencia
					</span>
					<Field name="rut">
						{({ field, meta }) => (
							<div className="form-group input-wrapper">
								<MaskedInput
									{...field}
									mask={rutMask}
									type="text"
									className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""
										}`}
									name="rut"
									aria-describedby="rutAyuda"
									autoComplete="off"
								/>
								<small
									id="rutAyuda"
									className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
										}`}
								>
									{meta.touched && meta.error
										? meta.error
										: "Ej. 12.345.678-9."}
								</small>
							</div>
						)}
					</Field>
					<span>Número de solicitud</span>
					<Field name="numerosolicitud">
						{({ field, meta }) => (
							<div className="form-group input-wrapper">
								<input
									{...field}
									type="text"
									className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""
										}`}
									name="numerosolicitud"
									aria-describedby="numerosolicitudAyuda"
									autoComplete="off"
								/>
								<small
									id="numerosolicitudAyuda"
									className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
										}`}
								>
									{meta.touched && meta.error
										? meta.error
										: "El número que te entregamos cuando realizaste la solicitud. Ej: 1711034202103."}
								</small>
							</div>
						)}
					</Field>
					<div className="justify-content-center d-flex mt-2">
						<Button
							variant="success"
							className="col-md-12"
							type="submit"
							disabled={!(formik.isValid && formik.dirty) || isLoading}
						>
							{isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
						</Button>
					</div>
					<div className="justify-content-center d-flex mt-2">
						<Button
							variant="link"
							className="col-md-12"
							onClick={() => {
								navigate("/");
							}}>
							Volver al paso anterior
						</Button>
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default FormConsultar;
